module.exports = __webpack_public_path__ + "img/reidar_sandanger.4e228913.png";